import { FromBaseInputMissing } from './from-base-context';
import { AC_DEFINITION_NOT_HELD } from './creature-armor-class';

/** A declared reference must hydrate before AC is published, including known misses. */
export function requireArmorClassDefinition<T>(id: string, definition: (id: string) => T | null): T {
    try {
        const row = definition(id);
        if (row != null) return row;
    } catch (error) {
        if (!(error instanceof FromBaseInputMissing) || error.dependency !== 'definition') throw error;
    }
    throw new FromBaseInputMissing(AC_DEFINITION_NOT_HELD, id);
}
